<template>
  <div class="addr_info room__block" @touchstart.stop>
    <div class="addr_info__panel">
      <h3>{{ $t("message.address.title") }}</h3>
      <img class="pay_list__close global_pointer" src="@/assets/imgs/close.png" alt="close" @click="close">
      <div class="addr_info__form">
        <template v-if="en">
          <div class="addr_info__item">
            <span class="require">*</span>
            <input type="text" v-model="addrform.firstName" :placeholder="$t('message.address.firstName')" />
          </div>
          <div class="addr_info__item">
            <span class="require">*</span>
            <input type="text" v-model="addrform.lastName" :placeholder="$t('message.address.lastName')" />
          </div>
        </template>
        <template v-else>
          <div class="addr_info__item">
            <span class="require">*</span>
            <input type="text" v-model="addrform.lastName" :placeholder="$t('message.address.lastName')" />
          </div>
          <div class="addr_info__item">
            <span class="require">*</span>
            <input type="text" v-model="addrform.firstName" :placeholder="$t('message.address.firstName')" />
          </div>
        </template>
        <p class="addr_info__tip">{{ $t("message.address.tips") }}</p>
        <div class="addr_info__item">
          <span class="require">*</span>
          <input type="text" v-model="addrform.mobile" :placeholder="$t('message.address.mobile')" />
        </div>
        <div class="addr_info__item">
          <span class="require">*</span>
          <input
            type="text"
            :placeholder="$t('message.address.country')"
            v-model="addrform.country"
            readonly
            @click="showPicker"
          />
        </div>
        <div class="addr_info__item">
          <span class="require">*</span>
          <input
            type="text"
            :placeholder="$t('message.address.province')"
            v-model="addrform.province"
            readonly
            @click="showAddress"
          />
        </div>
        <div class="addr_info__item global_pointer" @click="showSearchAddr=true">
          <span class="require">*</span>
          <input type="text" @click="showSearchAddr=true" readonly v-model="addrform.address" :placeholder="$t('message.address.detail')" />
        </div>
        <div class="addr_info__item">
          <span class="require">*</span>
          <input type="text" v-model="addrform.postCode" :placeholder="$t('message.address.postNum')" />
        </div>
      </div>
      <div class="addr_info__bottom_button global_pointer" @click="saveAddress">{{ $t('message.address.save') }}</div>
      <searchAddr :showSearchAddr.sync="showSearchAddr" :addressval="addrform" @getStreet="getStreet"/>
      <van-popup v-model="showCountryPicker" round position="bottom">
        <van-picker
          confirm-button-text="OK"
          cancel-button-text="Cancel"
          value-key="name"
          show-toolbar
          :columns="columns"
          @cancel="showCountryPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <van-popup v-model="showCascader" round position="bottom">
        <van-cascader
          v-model="cascaderValue"
          :title="$t('message.address.selectArea')"
          :options="options"
          @close="showCascader = false"
          @change="onChange"
          @finish="onFinish"
        />
      </van-popup>
    </div>
  </div>
</template>
<script>
import api from '@/api/api_list.js';
import { Picker, Cascader } from 'vant';
import searchAddr from './searchAddr.vue';

export default {
  name: 'addressInfo',
  data() {
    return {
      showCountryPicker: false,
      showCascader: false,
      addrform: {
        address: '',
        city: '',
        cityId: '',
        country: '',
        countryId: '',
        countryCode: '',
        defaultAddr: 0,
        countryNo: '',
        district: '',
        districtId: '',
        firstName: '',
        lastName: '',
        mobile: '',
        province: '',
        provinceId: '',
        postCode: '',
      },
      columns: [],
      options: [],
      cascaderValue: '',
      CountryList: [],
      ProvinceList: [],
      cityList: [],
      en:this.$i18n.locale === 'en',
      showSearchAddr: false,
    };
  },
  props: {
    id: {
      type: [Number, String],
      default: '',
    },
  },
  components: {
    [Picker.name]: Picker,
    [Cascader.name]: Cascader,
    searchAddr
  },
  // created() {
  //   this.getCountryList();
  //   if (this.id) {
  //     this.getDetail();
  //   }
  // },
  mounted(){
    console.log('id==========',this.id)
    this.getCountryList();
    if (this.id) {
      this.getDetail();
    }
  },
  methods: {
    onConfirm(data) {
      this.getProvince(data);
      this.addrform.countryNo = data.code;
      this.addrform.countryId = data.id;
      this.addrform.countryCode = String(data.telCode);
      this.$set(this.addrform, this.current, data.name);
      this.showCountryPicker = false;
    },
    async onChange(data) {
      const { selectedOptions, value } = data;
      if (value === selectedOptions[0].id && selectedOptions[0].regionLevel == 3) {
        const cityList = await this.getCity(selectedOptions[0]);
        this.options.forEach((item, index) => {
          if (item.id === selectedOptions[0].id) {
            this.options[index].children = cityList;
          }
        });
      }
    },
    onFinish({ selectedOptions }) {
      this.showCascader = false;
      selectedOptions.forEach((item) => {
        if (item.regionLevel === 3) {
          this.addrform.province = item.text;
          this.addrform.provinceId = item.id;
        } else if (item.regionLevel === 4) {
          this.addrform.city = item.text;
          this.addrform.cityId = item.id;
        }
      });
    },
    getCity(val) {
      return new Promise(async (rs, rj) => {
        this.cityList = [];
        const data = await this.getList({
          pid: val.id,
        });
        data.forEach((item) => {
          item.text = item.name;
          item.code = item.id;
          item.value = item.id;
        });
        this.cityList = data;
        rs(data);
      });
    },
    // 地址区域列表
    getList(val) {
      return new Promise(async (resolve, reject) => {
        try {
          api.get_addr_area(val).then((res) => {
            const { code, result } = res;
            if (!code) {
              resolve(result);
            }
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 国家列表
    async getCountryList() {
      if (this.CountryList && this.CountryList.length > 0) {
        this.columns = this.CountryList;
        return;
      }
      try {
        const data = await this.getList({});
        data.forEach((item) => {
          this.CountryList.push({
            ...item,
            text: item.name,
          });
        });
        this.columns = this.CountryList;
      } catch (err) {
        console.error(err);
      }
    },
    showPicker() {
      this.showCountryPicker = true;
      this.current = 'country';
      this.columns = this.CountryList;
    },
    showAddress() {
      this.showCascader = true;
    },
    async getProvince(val) {
      this.provinceList = [];
      this.cityList = [];
      const data = await this.getList({ pid: val.id });
      data.forEach((item) => {
        item.text = item.name;
        item.code = item.id;
        item.value = item.id;
        item.children = [];
      });
      this.provinceList = data;
      if (this.provinceList.length <= 0) {
        this.$set(this.addrform, 'province', '');
        this.$set(this.addrform, 'city', '');
      }
      this.options = this.provinceList;
    },
    // 获取地址详情
    async getDetail() {
      try {
        const { code, result } = await api.get_addr_info({id:this.id});
        if (!code) {
          this.addrform = result;
          if (this.addrform.countryId) {
            this.getProvince({ id: this.addrform.countryId });
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    },
    async saveAddress() {
      if (this.addrform.firstName === '') {
        this.$toast(this.$t('message.address.msg.firstName'));
        return;
      } else if(this.addrform.lastName === '') {
        this.$toast(this.$t('message.address.msg.lastName'));
        return;
      } else if (this.addrform.mobile === '') {
        this.$toast(this.$t('message.address.msg.mobile'));
        return;
      } else if (this.addrform.country === '') {
        this.$toast(this.$t('message.address.msg.country'));
        return;
      } else if (this.addrform.province === '') {
        this.$toast(this.$t('message.address.msg.province'));
        return;
      } else if (this.addrform.address === '') {
        this.$toast(this.$t('message.address.msg.address'));
        return;
      } else if (this.addrform.postCode === '') {
        this.$toast(this.$t('message.address.msg.zipCode'));
        return;
      }
      // const reg = /^[1][3456789]\d{9}$/
      if (this.addrform.mobile === '') {
        this.$toast(this.$t('message.address.msg.correctNumber'));
        return;
      }
      // this.switchval ? (this.addrform.defaultAddr = 1) : (this.addrform.defaultAddr = 0);
      this.addrform.defaultAddr = 1;
      try {
        console.log(this.addrform)
        if (this.id) {
          // 编辑
          const val = await api.update_addr(this.addrform);
          if (!val.code) {
            this.$toast(this.$t("message.address.msg.saveSuccess"));
            this.$emit('saveSuccess')
          } else {
            this.$toast(val.msg);
          }
        } else {
          // 新建
          const val = await api.save_addr(this.addrform);
          if (!val.code) {
            this.$toast(this.$t("message.address.msg.saveSuccess"));
            this.$emit('saveSuccess')
          } else {
            this.$toast(val.msg);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    },
    close(){
      this.$emit('close')
    },
    // 模糊搜索地址
    getStreet(place) {
        for (let key in place) {
            this.addrform[key] = place[key] || ''
        }
        if (place.province) {
            console.log(this.addrform)
            this.getProvince({ id: this.addrform.countryId })
        }
        this.showSearchAddr = false
    },
  },
};
</script>
<style lang="less">
.addr_info {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  &__panel {
    position: absolute;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
    padding: 50px 32px 0;
    box-sizing: border-box;
    text-align: left;
    & h3 {
      height: 40px;
      font-size: 24px;
      font-weight: bold;
      color: #231f20;
      line-height: 40px;
      margin: 0;
      padding: 0;
      text-align: left;
    }
  }
  &__form {
    max-height: 350px;
    overflow-y: auto;
  }
  &__item {
    font-size: 17px;
    display: flex;
    align-items: center;
    padding: 21px 0;
    border-bottom: 1px solid #e8e8e8;
    & .require {
      color: #f66355;
      margin-right: 8px;
    }
    & input {
      border: 0;
      border-radius: 0;
      font-size: 17px;
      outline: none;
    }
  }
  &__tip {
    height: 16px;
    font-size: 11.5px;
    font-weight: 500;
    color: #999999;
    line-height: 16px;
    margin: 0;
    padding: 0;
  }
  &__bottom_button{
    width: 100%;
    height: 46px;
    line-height: 46px;
    text-align: center;
    background: #222222;
    border-radius: 23px;
    font-size: 15px;
    color: #FFFFFF;
    margin: 27px 0 36px;
  }
}
</style>
